/* src/app/private/components/clients/client-details/client-details.component.scss */
.page-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.sidebar {
  width: 250px;
  background-color: #f1f1f1;
  padding: 1rem;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}
.sidebar ul {
  list-style: none;
  padding: 0;
}
.sidebar li {
  margin-bottom: 1rem;
  cursor: pointer;
  font-weight: 500;
}
.sidebar li:hover {
  color: #007bff;
}
.content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
}
.left-col {
  background-color: var(--p-dialog-background);
}
/*# sourceMappingURL=client-details.component.css.map */
